import moment from "moment";

export const formatTimeSetting = (timing: string) => {
  const durationObj = moment.duration(timing);
  const hourStr = String(durationObj.hours()).padStart(2, "0");
  const minuteStr = String(durationObj.minutes()).padStart(2, "0");
  return `${hourStr}:${minuteStr}`;
};
